import {Parameter, Signature} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalAddSignature} from "./PortalAddSignature";

export class PortalSignature extends Signature implements Parameter {
	constructor(data: any) {
		super(data);

		this.add = PortalAddSignature.fromJson(data?.add);
	}

	public static fromJson(data: any): PortalSignature {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalSignature(data);
	}

	public clone(): PortalSignature {
		return PortalSignature.fromJson(this.toJson());
	}
}